export default __webpack_public_path__ + "static/WorkOutAnytime-94648f1d0fd85c2ed93d96bc793b48f4.png";